import * as config from '../config'
import {Align} from "../class/align";

export default class Wall {
    constructor(scene, group) {
        this.scene = scene
        this.groupWall = group
        this.generateWalls();
    }

    generateWalls() {
        let down = this.scene.physics.add.sprite(
            0,
            this.scene.background.y + (this.scene.background.displayHeight / 2),
            'wall')
        down.displayWidth = config.width
        down.displayHeight = 0;
        down.wallType = 'down';
        Align.centerWidth(down)
        let left = this.scene.physics.add.sprite(
            1,
            this.scene.background.y,
            'wall')
        left.displayWidth = 0
        left.displayHeight = this.scene.background.y  * 2;
        left.body.immovable = true;
        left.wallType = 'left';
        let right = this.scene.physics.add.sprite(
            config.width,
            this.scene.background.y,
            'wall')
        right.displayWidth = 0
        right.displayHeight = this.scene.background.y * 2;
        right.wallType = 'right';
        let up = this.scene.physics.add.sprite(
            0,
            0,
            'wall')
        up.displayWidth = config.width
        up.displayHeight = 0;
        up.wallType = 'up';
        Align.centerWidth(up)
        this.groupWall.add(down);
        this.groupWall.add(left);
        this.groupWall.add(right);
        this.groupWall.add(up);
    }
}
